var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-white iq-footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row",staticStyle:{"z-index":"-1"}},[_c('div',{staticClass:"col-md-6"},[_c('ul',{staticClass:"list-inline mb-0"},[_vm._t("left")],2)]),_c('div',{staticClass:"col-md-6 text-right"},[_vm._t("right")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }